import authentificationService from '@/services/authentificationService'
import Vue from 'vue'
import App from './App.vue'
import './element-ui.js'
import './filters'
import './google-analytics'
import i18n from './i18n'
import router from './router'

Vue.config.productionTip = false

authentificationService
  .init()
  .then(isAuthenticated => {
    if (isAuthenticated) {
      new Vue({
        router,
        i18n,
        render: h => h(App),
      }).$mount('#app')
    } else {
      authentificationService.logIn()
    }
  })
  .catch(error => console.error('Failed to initialize SSO', error))

